import type { IOffer } from 'shared/offer';
import type { TUser } from 'shared/types/user';
import { getIsCpcAuction } from 'shared/utils/auction';
import { isNotSearcher } from 'shared/utils/isNotSearcher';

interface IShouldShowPromotionDescriptionParams {
  offer: IOffer;
  user: TUser;
  /** Фича-флаг `auction.cpcEnabled`. */
  isCpcAuctionEnabled: boolean;
  /** Фича-флаг `isPerformanceVASPilot.Enabled`. */
  isPerformanceVasEnabled: boolean;
}

/**
 * Реально ли рендерится блок описания продвижения (PromotionDescription) на карточке.
 *
 * Единый источник истины для рендера (`PromotionDescriptionContainer`) и телеметрии показов —
 * чтобы метрика показа описания не расходилась с тем, что видит пользователь.
 *
 * Показывается только не-искателям (`isNotSearcher`), при непустом `promotionDescription`, и либо для
 * CPC-объявления, либо при включённом пилоте perf-VAS.
 */
export function shouldShowPromotionDescription({
  offer,
  user,
  isCpcAuctionEnabled,
  isPerformanceVasEnabled,
}: IShouldShowPromotionDescriptionParams): boolean {
  if (!isNotSearcher(user) || !offer?.promotion?.promotionDescription) {
    return false;
  }

  const isCpcOffer = isCpcAuctionEnabled && getIsCpcAuction(offer);

  return isCpcOffer || isPerformanceVasEnabled;
}
